/**
 * Traditional Chinese (TWD base) cross-currency transactions for the
 * multi-currency use case. Uses the real multi-currency accounts (港島返利卡
 * in HKD, 美股組合 in USD) so the NT$/HK$/$ mix and the cross-currency
 * transfer pair feel at home.
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_CROSS_CURRENCY_TRANSACTIONS_ZH_TW = [
	{
		id: 'xcur-1',
		isTransferPair: true,
		date: '2026-08-05',
		type: 'Transfer',
		amount: 64200,
		description: '轉入美股組合',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '儲蓄',
		pairedType: 'Transfer',
		pairedAmount: 2000,
		pairedCurrencySymbol: '$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '美股組合',
		pairedAccountId: 'acc-joke',
		pairedDate: '2026-08-05',
	},
	{
		id: 'xcur-2',
		date: '2026-08-04',
		type: 'Deposit',
		amount: 112000,
		description: '薪水',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '收入',
	},
	{
		id: 'xcur-3',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 1560,
		description: '超市',
		accountId: 'acc-credit',
		accountName: '港島返利卡',
		currency: 'HKD',
		currencySymbol: 'HK$',
		currencyDecimalPlaces: 2,
		tagNames: '餐飲',
	},
	{
		id: 'xcur-4',
		date: '2026-07-29',
		type: 'Purchase',
		amount: 128,
		description: '美區訂閱',
		accountId: 'acc-joke',
		accountName: '美股組合',
		currency: 'USD',
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		tagNames: '工作',
	},
	{
		id: 'xcur-5',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 3200,
		description: '東京飯店',
		accountId: 'acc-jpy',
		accountName: '日圓卡',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '旅行',
	},
];
